export enum SchoolType{
  ELEMENTARY= "ELEMENTARY",
  GENERAL_SECONDARY= "GENERAL_SECONDARY",
  INTERMEDIATE_SECONDARY = "INTERMEDIATE_SECONDARY",
  GRAMMAR = "GRAMMAR",
  COMPREHENSIVE = "COMPREHENSIVE",
  VOCATIONAL = "VOCATIONAL",
  SPECIAL = "SPECIAL",
  DENOMINATIONAL_ELEMENTARY = "DENOMINATIONAL_ELEMENTARY",
  CATHOLIC_GENERAL_SECONDARY = "CATHOLIC_GENERAL_SECONDARY",
  OTHER = "OTHER"
}
